import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk' // redux middle-ware
import reducers from './reducers' //connect all reduce

const composeEnhancers =
    (typeof window !== 'undefined'  && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
export const initializeStore = (initialState = {}) =>
    createStore(reducers, initialState, composeEnhancers(applyMiddleware(thunk)));

export const withServerStore = (getServerSideProps) => async (context) => {
    const store = initializeStore();
    const result = await getServerSideProps({ ...context, store });
    if (!result.props) return result;
    return {
        ...result,
        props: { ...(await result.props), initialReduxState: store.getState() },
    };
};

export default typeof window !== 'undefined'
    ? initializeStore(window.__NEXT_DATA__?.props?.pageProps?.initialReduxState
        || window.__NEXT_DATA__?.props?.initialReduxState)
    : null;